/* eslint-disable */

/**
 * The web client is requesting that mobile client opens a native deep link.
 * Should be sent from the web to mobile.
 */
export interface TaxWebBridgeNativeDeepLinkEventRequest {
  /**
   * Native Client Route Deep Link.
   * See cash-client-route for details on how to format the URL.
   */
  native_deep_link?: string;
  /**
   * A flag that lets the mobile client know it should return the status without triggering the deep link.
   * Default: false
   */
  is_deep_link_candidate?: boolean;
}

/**
 * A response for `TaxWebBridgeNativeDeepLinkEventRequest`.
 * It contains the data necessary for web to know if the native client
 * handled the deep link successfully.
 * Should be sent from mobile to web.
 */
export interface TaxWebBridgeNativeDeepLinkEventResponse {
  /** The status of the client handling of the requested deep link. */
  status?: TaxWebBridgeNativeDeepLinkEventResponseStatus;
}

export enum TaxWebBridgeNativeDeepLinkEventResponseStatus {
  HANDLED = "HANDLED",
  UNSUPPORTED = "UNSUPPORTED",
}
